<template>
  <div v-if="easyFlowVisible" style="height: 100%" @click="formShow = false">
    <div class="settingbox" style="height: 40px">
      <!-- <el-button size="mini" type="primary" @click="save">保存</el-button> -->
      <el-button size="mini" type="primary" @click="back">返回</el-button>
      <div class="version">
        <span style="font-size: 12px">版本号：</span>
        <el-select
          size="mini"
          :value="now_version"
          placeholder="选择版本号"
          @change="versionChange"
        >
          <el-option
            :label="item.version"
            :value="item.version"
            v-for="item of versions"
            :key="item.id"
          ></el-option>
          <el-option :value="-1" style="text-align: center">
            <span style="text-align: center"
              ><i class="el-icon-circle-plus-outline"
            /></span>
            <span style="text-align: center">添加</span>
          </el-option>
        </el-select>
      </div>
    </div>
    <div style="display: flex; height: calc(100% - 40px)">
      <div style="width: 230px; border-right: 1px solid #dce3e8">
        <node-menu @addNode="addNode" ref="nodeMenu"></node-menu>
      </div>
      <div id="efContainer" ref="efContainer" class="container" v-flowDrag>
        <template v-for="node in data.nodeList">
          <flow-node
            :id="node.id"
            :key="node.id"
            :node="node"
            :activeElement="activeElement"
            :flow="flow"
            @changeNodeSite="changeNodeSite"
            @nodeRightMenu="nodeRightMenu"
            @clickNode="clickNode"
            @click.native.stop
          >
          </flow-node>
        </template>
        <div style="position: absolute; top: 2000px; left: 3500px">&nbsp;</div>
      </div>
      <div
        v-show="formShow"
        style="
          width: 300px;
          border-left: 1px solid #dce3e8;
          background-color: #fbfbfb;
        "
      >
        <flow-node-form
          ref="nodeForm"
          :flow="flow"
          @setLineLabel="setLineLabel"
          @repaintEverything="repaintEverything"
          @del="deleteElement"
          @click.native.stop
        ></flow-node-form>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import "./jsplumb";
import { easyFlowMixin } from "@/components/ef/mixins";
import flowNode from "@/components/ef/node";
import nodeMenu from "@/components/ef/node_menu";
import FlowNodeForm from "./node_form";
import lodash from "lodash";

export default {
  props: {
    flow: {
      type: Object,
    },
  },
  data() {
    return {
      loading: "", //加载中控件
      flow_id: "", //工作流id
      // jsPlumb 实例
      jsPlumb: null,
      // 控制画布销毁
      easyFlowVisible: true,
      // 控制流程数据显示与隐藏
      flowInfoVisible: false,
      // 是否加载完毕标志位
      loadEasyFlowFinish: false,
      flowHelpVisible: false,
      // 数据
      data: {
        nodeList: [],
        lineList: [],
        name: "",
      },
      // 激活的元素、可能是节点、可能是连线
      activeElement: {
        // 可选值 node 、line
        type: undefined,
        // 节点ID
        nodeId: undefined,
        // 连线ID
        sourceId: undefined,
        targetId: undefined,
      },
      zoom: 0.5,
      formShow: false,
    };
  },
  computed: {
    versions() {
      return this.$store.state?.flowVersion?.versions ?? [];
    },
    now_version() {
      return this.$store.state?.flowVersion?.now_version?.version ?? "";
    },
  },
  // 一些基础配置移动该文件中
  mixins: [easyFlowMixin],
  components: {
    draggable,
    flowNode,
    nodeMenu,
    FlowNodeForm,
  },
  directives: {
    flowDrag: {
      bind(el, binding, vnode, oldNode) {
        if (!binding) {
          return;
        }
        el.onmousedown = (e) => {
          if (e.button == 2) {
            // 右键不管
            return;
          }
          //  鼠标按下，计算当前原始距离可视区的高度
          let disX = e.clientX;
          let disY = e.clientY;
          el.style.cursor = "move";

          document.onmousemove = function (e) {
            // 移动时禁止默认事件
            e.preventDefault();
            const left = e.clientX - disX;
            disX = e.clientX;
            el.scrollLeft += -left;

            const top = e.clientY - disY;
            disY = e.clientY;
            el.scrollTop += -top;
          };

          document.onmouseup = function (e) {
            el.style.cursor = "auto";
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 改变版本号
     */
    versionChange(e) {
      if (e === -1) {
        this.addVersion();
        return;
      }
      this.$store.dispatch(
        "flowVersion/nowVersionChange",
        this.$store.state.flowVersion.versions.find((x) => x.version === e)
      );
      this.getInfo();
      this.jsPlumb = jsPlumb.getInstance();
      this.getDefault();
    },
    addVersion() {
      this.flow.workflowVersiongetVersion().then((res) => {
        this.flow.workflowVersiongetList().then((res) => {
          this.$store.dispatch("flowVersion/versionsChange", res.data);
        });
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 开始工作流流程设计
     */
    async start(flow_id) {
      this.flow_id = flow_id || "";
      await this.getInfo();
      this.jsPlumb = jsPlumb.getInstance();
      this.getDefault();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取信息
     */
    getInfo() {
      return new Promise((resolve, reject) => {
        const getOptionsRole = this.flow.getOptionsRole();
        const getOptionsUser = this.flow.getOptionsUser();
        const getOptionsCondition = this.flow.getOptionsCondition({
          flow_id: this.flow_id,
          flow_version:
            this.$store.state?.flowVersion?.now_version?.version ?? 1,
        });
        Promise.all([getOptionsRole, getOptionsUser, getOptionsCondition]).then(
          (res) => {
            resolve();
          }
        );
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取原数据
     */
    getDefault() {
      this.loading = this.$commonUtil.loading("获取工作流数据中...");
      this.flow
        .workflowGetFlowProcess({
          flow_id: this.flow_id,
          flow_version:
            this.$store.state?.flowVersion?.now_version?.version ?? 1,
        })
        .then((res) => {
          let obj = {
            lineList: res.data.link_list.map((x) => {
              x.label =
                this.flow?.options_condition?.find(
                  (y) => y.value === x.condition
                )?.name ?? "";
              x.from = String(x.from);
              x.to = String(x.to);
              return x;
            }),
            name: "",
            nodeList: res.data.process_list.map((x) => {
              let ico = "";
              if (x.process_type === "is_judge") {
                ico = "el-icon-rank";
              } else if (x.process_type === "is_one") {
                ico = "el-icon-video-play";
              } else if (x.process_type === "repeat_send") {
                ico = "el-icon-s-promotion";
              } else if (x.process_type === "is_end") {
                ico = "el-icon-video-pause";
              } else {
                ico = "el-icon-coordinate";
              }
              return {
                type: x.process_type,
                id: String(x.id),
                process_name: x.process_name,
                left: x.style.left,
                top: x.style.top,
                flow_app: x.flow_app,
                ico,
                auto_person: x.auto_person,
                user_ids: x.user_ids,
                user_text: x.user_text,
                role_ids: x.role_ids,
                role_text: x.role_text,
                work_id: x.work_id,
                work_text: x.work_text,
                is_back: x.is_back,
                wf_action: x.wf_action,
                node_name: x.node_name,
                wf_mode: x.wf_mode,
                end_flow: x.end_flow || 0,
              };
            }),
          };
          this.$nextTick(() => {
            this.dataReload(obj);
          });
        })
        .finally(() => {
          this.loading.close();
        });
    },
    // 返回唯一标识
    getUUID() {
      return "temp_" + new Date().getTime();
      // return Math.random().toString(36).substr(3, 10);
    },
    jsPlumbInit() {
      this.jsPlumb.ready(() => {
        // 导入默认配置
        this.jsPlumb.importDefaults(this.jsplumbSetting);
        // 会使整个jsPlumb立即重绘。
        this.jsPlumb.setSuspendDrawing(false, true);
        // 初始化节点
        this.loadEasyFlow();
        // 单点击了连接线, https://www.cnblogs.com/ysx215/p/7615677.html
        this.jsPlumb.bind("click", (conn, originalEvent) => {
          setTimeout(() => {
            this.formShow = true;
          });
          this.activeElement.type = "line";
          this.activeElement.sourceId = conn.sourceId;
          this.activeElement.targetId = conn.targetId;
          this.$refs.nodeForm.lineInit({
            from: conn.sourceId,
            to: conn.targetId,
            label: conn.getLabel(),
            condition:
              this.data.lineList?.find(
                (x) => x.from === conn.sourceId && x.to === conn.targetId
              )?.condition ?? "",
          });
        });
        // 连线
        this.jsPlumb.bind("connection", (evt) => {
          let from = evt.source.id;
          let to = evt.target.id;
          if (this.loadEasyFlowFinish) {
            this.data.lineList.push({ from: from, to: to });
          }
        });

        // 删除连线回调
        this.jsPlumb.bind("connectionDetached", (evt) => {
          this.deleteLine(evt.sourceId, evt.targetId);
        });

        // 改变线的连接节点
        this.jsPlumb.bind("connectionMoved", (evt) => {
          this.changeLine(evt.originalSourceId, evt.originalTargetId);
        });

        // 连线右击
        this.jsPlumb.bind("contextmenu", (evt) => {
          console.log("contextmenu", evt);
        });

        // 连线
        this.jsPlumb.bind("beforeDrop", (evt) => {
          let from = evt.sourceId;
          let to = evt.targetId;
          if (from === to) {
            this.$message.error("节点不支持连接自己");
            return false;
          }
          if (this.hasLine(from, to)) {
            this.$message.error("该关系已存在,不允许重复创建");
            return false;
          }
          if (this.hashOppositeLine(from, to)) {
            this.$message.error("不支持两个节点之间连线回环");
            return false;
          }
          this.$message.success("连接成功");
          return true;
        });

        // beforeDetach
        this.jsPlumb.bind("beforeDetach", (evt) => {});
        this.jsPlumb.setContainer(this.$refs.efContainer);
      });
    },
    // 加载流程图
    loadEasyFlow() {
      // 初始化节点
      for (var i = 0; i < this.data.nodeList.length; i++) {
        let node = this.data.nodeList[i];
        // 设置源点，可以拖出线连接其他节点
        this.jsPlumb.makeSource(
          node.id,
          lodash.merge(this.jsplumbSourceOptions, {})
        );
        // // 设置目标点，其他源点拖出的线可以连接该节点
        this.jsPlumb.makeTarget(node.id, this.jsplumbTargetOptions);
        if (!node.viewOnly) {
          this.jsPlumb.draggable(node.id, {
            containment: "parent",
            stop: function (el) {},
          });
        }
      }
      // 初始化连线
      for (var i = 0; i < this.data.lineList.length; i++) {
        let line = this.data.lineList[i];
        var connParam = {
          source: line.from,
          target: line.to,
          label: line.label ? line.label : "",
          connector: line.connector ? line.connector : "",
          anchors: line.anchors ? line.anchors : undefined,
          paintStyle: line.paintStyle ? line.paintStyle : undefined,
        };
        this.jsPlumb.connect(connParam, this.jsplumbConnectOptions);
      }
      this.$nextTick(function () {
        this.loadEasyFlowFinish = true;
      });
    },
    // 设置连线条件
    setLineLabel(from, to, condition) {
      let param = {};
      param.flow_id = this.flow_id;
      param.from = from;
      param.to = to;
      param.condition = condition;
      param.flow_version =
        this.$store.state?.flowVersion?.now_version?.version ?? 1;
      const label =
        this.flow?.options_condition?.find((y) => y.value === condition)
          ?.name ?? "";
      this.flow.workflowSaveLink(param).then((res) => {
        // this.getDefault();
        var conn = this.jsPlumb.getConnections({
          source: from,
          target: to,
        })[0];
        if (!label || label === "") {
          conn.removeClass("flowLabel");
          conn.addClass("emptyFlowLabel");
        } else {
          conn.addClass("flowLabel");
        }
        conn.setLabel({
          label: label,
        });
        this.data.lineList.forEach(function (line) {
          if (line.from == from && line.to == to) {
            line.label = label;
            line.condition = condition;
          }
        });
        this.formShow = false;
      });
    },
    // 删除激活的元素
    deleteElement() {
      if (this.activeElement.type === "node") {
        this.deleteNode(this.activeElement.nodeId);
      } else if (this.activeElement.type === "line") {
        this.$confirm("确定删除所点击的线吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let param = {
              flow_id: this.flow_id,
              from: this.activeElement.sourceId,
              to: this.activeElement.targetId,
              flowVersion: this.$store.state?.now_version?.version ?? 1,
            };
            this.flow.workflowDelLink(param).then((res) => {
              // this.getDefault();
              var conn = this.jsPlumb.getConnections({
                source: this.activeElement.sourceId,
                target: this.activeElement.targetId,
              })[0];
              this.jsPlumb.deleteConnection(conn);
              this.formShow = false;
            });
          })
          .catch(() => {});
      }
    },
    // 删除线
    deleteLine(from, to) {
      this.data.lineList = this.data.lineList.filter(function (line) {
        if (line.from == from && line.to == to) {
          return false;
        }
        return true;
      });
    },
    // 改变连线
    changeLine(oldFrom, oldTo) {
      this.deleteLine(oldFrom, oldTo);
    },
    // 改变节点的位置
    changeNodeSite(data) {
      for (var i = 0; i < this.data.nodeList.length; i++) {
        let node = this.data.nodeList[i];
        if (node.id === data.nodeId) {
          node.left = data.left;
          node.top = data.top;
        }
      }
    },
    /**
     * 拖拽结束后添加新的节点
     * @param evt
     * @param nodeMenu 被添加的节点对象
     * @param mousePosition 鼠标拖拽结束的坐标
     */
    addNode(evt, nodeMenu, mousePosition) {
      var screenX = evt.originalEvent.clientX,
        screenY = evt.originalEvent.clientY;
      let efContainer = this.$refs.efContainer;
      var containerRect = efContainer.getBoundingClientRect();
      var left = screenX,
        top = screenY;
      // 计算是否拖入到容器中
      if (
        left < containerRect.x ||
        left > containerRect.width + containerRect.x ||
        top < containerRect.y ||
        containerRect.y > containerRect.y + containerRect.height
      ) {
        this.$message.error("请把节点拖入到画布中");
        return;
      }
      left = left - containerRect.x + efContainer.scrollLeft;
      top = top - containerRect.y + efContainer.scrollTop;
      // 居中
      left -= 85;
      top -= 16;
      var nodeId = this.getUUID();
      // 动态生成名字
      var origName = nodeMenu.process_name;
      var nodeName = origName;
      var index = 1;
      while (index < 10000) {
        var repeat = false;
        for (var i = 0; i < this.data.nodeList.length; i++) {
          let node = this.data.nodeList[i];
          if (node.process_name === nodeName) {
            nodeName = origName + index;
            repeat = true;
          }
        }
        if (repeat) {
          index++;
          continue;
        }
        break;
      }
      let node;
      nodeMenu.type === "is_judge"
        ? (node = {
            type: nodeMenu.type,
            id: nodeId,
            process_name: nodeName,
            left: left + "px",
            top: top + "px",
            ico: nodeMenu.ico,
            wf_mode: 2, //判断node节点固定为流转
          })
        : (node = {
            type: nodeMenu.type,
            id: nodeId,
            process_name: nodeName,
            left: left + "px",
            top: top + "px",
            flow_app: "agency",
            ico: nodeMenu.ico,
            auto_person: 1,
            user_ids: "",
            user_text: "",
            role_ids: "",
            role_text: "",
            work_id: "",
            work_text: "",
            is_back: 1,
            wf_action: "",
            node_name: "",
            wf_mode: 1,
            end_flow: 0,
          });
      this.data.nodeList.push(node);
      this.$nextTick(function () {
        this.jsPlumb.makeSource(nodeId, this.jsplumbSourceOptions);
        this.jsPlumb.makeTarget(nodeId, this.jsplumbTargetOptions);
        this.jsPlumb.draggable(nodeId, {
          containment: "parent",
          stop: function (el) {},
        });
      });
    },
    /**
     * 删除节点
     * @param nodeId 被删除节点的ID
     */
    deleteNode(nodeId) {
      this.$confirm("确定要删除节点" + nodeId + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          /**
           * 这里需要进行业务判断，是否可以删除
           */
          this.data.nodeList = this.data.nodeList.filter(function (node) {
            if (node.id === nodeId) {
              // 伪删除，将节点隐藏，否则会导致位置错位
              // node.show = false
              return false;
            }
            return true;
          });
          this.$nextTick(() => {
            if (String(nodeId).indexOf("temp") === -1) {
              this.deleteNodeTotal(nodeId);
            } else {
              this.jsPlumb.removeAllEndpoints(nodeId);
              this.formShow = false;
            }
          });
        })
        .catch(() => {});
      return true;
    },
    deleteNodeTotal(nodeId) {
      this.flow
        .workflowDelProcess({
          flow_id: this.flow_id,
          process_id: nodeId,
          flow_version:
            this.$store.state?.flowVersion?.now_version?.version ?? 1,
        })
        .then((res) => {
          this.jsPlumb.removeAllEndpoints(nodeId);
          this.formShow = false;
          // this.getDefault();
        });
    },
    clickNode(nodeId) {
      this.formShow = true;
      this.activeElement.type = "node";
      this.activeElement.nodeId = nodeId;
      this.$refs.nodeForm.nodeInit(this.data, nodeId);
    },
    // 是否具有该线
    hasLine(from, to) {
      for (var i = 0; i < this.data.lineList.length; i++) {
        var line = this.data.lineList[i];
        if (line.from === from && line.to === to) {
          return true;
        }
      }
      return false;
    },
    // 是否含有相反的线
    hashOppositeLine(from, to) {
      return this.hasLine(to, from);
    },
    nodeRightMenu(nodeId, evt) {
      this.menu.show = true;
      this.menu.curNodeId = nodeId;
      this.menu.left = evt.x + "px";
      this.menu.top = evt.y + "px";
    },
    repaintEverything(node) {
      let param = {};
      String(node.id).indexOf("temp") > -1 || (param.id = node.id); //若id中包含temp表明为虚拟id,即新增，不提交id;若为实际id，即为编辑
      param.flow_id = this.flow_id;
      param.process_name = node.process_name;
      param.process_type = node.type;
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        node.type !== "repeat_send" &&
        (param.flow_app = node.flow_app);
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        (param.auto_person = node.auto_person);
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        (param.user_ids = param.auto_person === 1 ? node.user_ids : "");
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        (param.user_text = param.auto_person === 1 ? node.user_text : "");
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        (param.role_ids = param.auto_person === 2 ? node.role_ids : "");
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        (param.role_text = param.auto_person === 2 ? node.role_text : "");
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        (param.work_id = param.auto_person === 3 ? node.work_id : "");
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        (param.work_text = param.auto_person === 3 ? node.work_text : "");
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        node.type !== "repeat_send" &&
        (param.is_back = node.is_back);
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        node.type !== "repeat_send" &&
        (param.wf_action = node.wf_action);
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        node.type !== "repeat_send" &&
        (param.node_name = node.node_name);
      node.type !== "is_end" && (param.wf_mode = node.wf_mode);
      node.type !== "is_judge" &&
        node.type !== "is_end" &&
        node.type !== "repeat_send" &&
        (param.end_flow = node.end_flow);
      param.style = {
        top: node.top,
        left: node.left,
      };
      param.flow_version =
        this.$store.state?.flowVersion?.now_version?.version ?? 1;
      this.flow
        .workflowSaveProcess(param)
        .then((res) => {
          this.data.nodeList.forEach((node) => {
            if (node.id == this.activeElement.nodeId) {
              node.id = res.data.process_id;
            }
          });
          this.activeElement.nodeId = res.data.process_id;
          let obj = {
            lineList: this.data.lineList,
            name: "",
            nodeList: this.data.nodeList,
          };
          this.dataReload(obj);
          this.formShow = false;
          // this.getDefault();
          // this.jsPlumb.repaint();
        })
        .catch((err) => {
          this.getDefault();
          this.jsPlumb.repaint();
        });
    },
    // 加载流程图
    dataReload(data) {
      this.easyFlowVisible = false;
      this.data.nodeList = [];
      this.data.lineList = [];
      this.$nextTick(() => {
        data = data?.nodeList ? lodash.cloneDeep(data) : this.data;
        this.easyFlowVisible = true;
        this.data = data;
        this.$nextTick(() => {
          this.jsPlumb = jsPlumb.getInstance();
          this.$nextTick(() => {
            this.jsPlumbInit();
          });
        });
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 页面返回
     */
    back() {
      this.$router.go(-1);
    },
    // save() {
    //   let data = this.data;
    //   console.log(data);
    //   this.$emit("submit", data);
    // },
  },
};
</script>
<style lang="scss" scoped>
.settingbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  border-bottom: 1px solid #dce3e8;
}
</style>
